export default __webpack_public_path__ + "static/media/Punto_10_Chiesa_degli_Olandesi_ITA_Def.896efa92.aac";